import { routes } from "utils/routers.constants";

export const DataHeader = [
  {
    id: 11,
    title: 'Home',
    router: routes.HOME,
    icon: 'home',
    admin: false,
    permission: true
  },
  {
    id: 2,
    title: 'Agenda',
    router: routes.FINANCIAL_AGENDA,
    icon: 'date_range',
    admin: false,
    permission: true
  },
  {
    id: 3,
    title: 'Pagamentos',
    router: routes.SALES_REPORTS,
    icon: 'assignment',
    admin: false,
    permission: true
  },
  {
    id: 5,
    title: 'Conta Corrente',
    router: routes.FINANCES,
    icon: 'account_balance',
    admin: false,
    permission: true
  },
  {
    id: 9,
    title: 'Planos de Pagamento',
    router: routes.PAYMENTPLAN,
    icon: 'local_atm_outlined_icon',
    admin: false,
    permission: true
  },
  {
    id: 4,
    title: 'Relatórios',
    router: routes.ALL_REPORTS,
    icon: 'request_page',
    admin: false,
    permission: true
  },
  {
    id: 10,
    title: 'Conciliação',
    router: routes.RECONCILIATION,
    icon: 'swap_horizontal_circle',
    admin: false,
    hasReconciliation: true,
    permission: false
  },
  {
    id: 24,
    title: 'Recebíveis',
    router: routes.SCHEDULES_SELLER,
    icon: 'monetization_on',
    admin: false,
    permission: true,
    hideForAdmins: true,
  },
  {
    id: 12,
    title: 'Suporte',
    router: routes.SUPPORT,
    icon: 'info_icon',
    admin: false,
    permission: true,
  },
  {
    id: 13,
    title: 'Dashboard',
    router: routes.SUMMARY,
    icon: 'dashboard',
    admin: true,
    permission: false,
  },
  {
    id: 6,
    title: 'Gerenciar usuários',
    router: routes.USERS_MANAGEMENT,
    icon: 'person_page',
    admin: true,
    permission: false
  },
  {
    id: 7,
    title: 'Gerenciar subsellers',
    router: routes.SUBSELLERS,
    icon: 'corporate_fare',
    admin: true,
    permission: false
  },
  {
    id: 8,
    title: 'Recebíveis',
    router: routes.SCHEDULES,
    icon: 'attach_money',
    admin: true,
    permission: false
  },
  {
    id: 15,
    title: 'Lotes de pagamento',
    router: routes.PAYMENT_BATCHES,
    icon: 'batch_prediction',
    admin: true,
    permission: false
  },
  {
    id: 17,
    title: 'Interface com o Banco',
    router: routes.SIM_BANK,
    icon: 'assured_workload',
    admin: true,
    permission: false
  },
  {
    id: 16,
    title: 'Saldo dos sellers',
    router: routes.SELLERS_BALANCES,
    icon: 'account_balance_wallet',
    admin: true,
    permission: false
  },
  {
    id: 14,
    title: 'FAQ',
    router: routes.FAQ,
    icon: 'question_answer',
    admin: true,
    permission: false
  },
];